console.warn(
  '[@tanstack/start] Warning: This package has moved to @tanstack/react-start. Please switch to the new package, as this package will be dropped soon.',
)
export * from '@tanstack/react-start-server'
